module.exports = __webpack_public_path__ + "img/d68a0bff100f32e648d2fe4363aa2981.svg";